import React from 'react';
import { LayoutOption } from '../LayoutOption';
import styles from '../LayoutSwitchControl.module.scss';
import { LayoutButton } from './LayoutButton';
export var LayoutOptions = function (_a) {
    var _b = _a.showDivider, showDivider = _b === void 0 ? true : _b, locResources = _a.locResources, onChangeLayout = _a.onChangeLayout, _c = _a.displayMode, displayMode = _c === void 0 ? [LayoutOption.List, LayoutOption.Grid] : _c;
    return (React.createElement("div", { className: styles['layout-switcher'] },
        showDivider && React.createElement("span", { className: styles['action-divider'] }),
        displayMode.map(function (mode) { return (React.createElement(LayoutButton, { layoutPreference: mode, key: mode, title: mode === LayoutOption.List
                ? locResources.listTitle
                : locResources.gridTitle, onSelectLayout: onChangeLayout })); })));
};
//# sourceMappingURL=LayoutOptions.js.map